<template>
  <div class="pgStyle" :style="{ fontSize: fonts.font18 + 'px' }">
    <b-btn
      v-b-toggle.loans class="btnCollapse"
      :style="{ fontSize: fonts.font26 + 'px' }">
      {{ loans.header }}
    </b-btn>
    <b-collapse visible id="loans" class="bCard">
      <div class="bCard">
        <div class="groupHeader">
          <span class="grHead" style="width: 25%">Note #</span>
          <span class="grHead" style="width: 25%">Payment</span>
          <span class="grHead" style="width: 25%">Balance</span>
          <span class="grHead" style="width: 25%">Delq</span>
        </div>
        <div v-for="ln in loans.lar" :key="ln.note">
          <div>
            <div v-show="!ln.isActive"
                 :style="ln.style"
                 @click="toggleLoan(ln)">
              <div
                class="groupSection"
                :style="ln.highlight"
                @mouseenter="mouseEnter(ln)"
                @mouseleave="mouseExit(ln)">
                <div class="grPrime" style="width: 25%">{{ ln.note }}</div>
                <div class="grRight" style="width: 25%">{{ ln.$dPay }}</div>
                <div class="grRight" style="width: 25%">{{ ln.$bal }}</div>
                <div class="grRight" style="width: 25%">{{ ln.$dlq }}</div>
              </div>
            </div>
            <div v-show="ln.isActive" class="detailBox"
                 :style="ln.style" @click="clickDetailBox(ln)">
              <div class="groupSection" :style="ln.style">
                <div @click="toggleLoan(ln)" size="sm" class="grPrime" style="width: 25%">
                  {{ ln.note }}
                </div>
                <div class="grRight" style="width: 25%">{{ ln.$dPay }}</div>
                <div class="grRight" style="width: 25%">{{ ln.$bal }}</div>
                <div class="grRight" style="width: 25%">{{ ln.$dlq }}</div>
              </div>
              <b-button-group id="btnGroup">
                <b-button id="btnHist"
                          @click="doHistory(ln)">
                  Show History
                </b-button>
                <b-button id="btnXfer"
                          @click="doXfer(ln)">
                  Make Payment
                </b-button>
                <b-button id="btnClose"
                          @click="toggleLoan(ln)">
                  Close
                </b-button>
              </b-button-group>
              <div :style="ln.style">
                <!-- start of loan top -->
                <div class="loanDetail">
                  <div class="detailItem">
                    <div class="ddLeft">Note Number:</div>
                    <div class="ddRight">{{ ln.note }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Contractual Payment:</div>
                    <div class="ddRight">{{ ln.$rPay }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Desired Payment:</div>
                    <div class="ddRight">{{ ln.$dPay }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Current Balance:</div>
                    <div class="ddRight">{{ ln.$bal }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Payment Frequency:</div>
                    <div class="ddRight">{{ ln.FREQ }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Delinquent Amount:</div>
                    <div class="ddRight">{{ ln.$dlq }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">APR:</div>
                    <div class="ddRight">{{ ln.APR }}</div>
                  </div>
                </div>
                <!-- end of loan top -->
                <!-- start of loan bottom -->
                <div class="loanDetail">
                  <div class="detailItem">
                    <div class="ddLeft">Approved Limit:</div>
                    <div class="ddRight">{{ ln.$limit }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Available Amount:</div>
                    <div class="ddRight">{{ ln.$avail }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Next Payment Due:</div>
                    <div class="ddRight">{{ ln.NPDD }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Today's Payoff:</div>
                    <div class="ddRight">{{ ln.$payoff }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Interest Per Day:</div>
                    <div class="ddRight">{{ ln.perDiem }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">YTD Interest:</div>
                    <div class="ddRight">{{ ln.$ytd }}</div>
                  </div>
                  <div class="detailItem">
                    <div class="ddLeft">Status:</div>
                    <div class="ddRight">{{ ln.openStatus }}</div>
                  </div>
                </div>
                <!-- end of loan bottom -->
              </div>
              <!-- end of Detail for Loan -->
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  name: 'z-loanSummary',
  data() {
    return {
      updateCount: 0,
      timeOutDoubleClick: 0,
    };
  },
  watch: {
    Lcc() {
      this.$forceUpdate();
    },
    myTenthSecond() {
      if (this.timeOutDoubleClick > 0) this.timeOutDoubleClick -= 1;
    },
  },
  computed: {
    Lcc() {
      return this.$store.getters.getLcc;
    },
    loans() {
      return this.$store.getters.getLoans;
    },
    winSize() {
      return this.$store.getters.getWinSize;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    trHigh() {
      return this.$store.getters.getTrHigh;
    },
    myTenthSecond() {
      return this.$store.getters.getMyTenth;
    },
  },
  methods: {
    doHistory(ln) {
      this.$store.commit('setSearchDesc', ''); // No search name
      const ahInfo = {};
      ahInfo.cun = this.cun;
      ahInfo.acct = this.member.acct;
      ahInfo.share = 'L';
      ahInfo.quan = 21;
      ahInfo.maxTr = this.trHigh;
      ahInfo.option = 0;
      ahInfo.note = ln.note;
      ahInfo.desc = `Note # ${ln.note}`;
      this.$store.commit('initHist', ahInfo);
    },
    doXfer(ln) {
      const xfInfo = {};
      xfInfo.cun = this.cun;
      xfInfo.acct = this.member.acct;
      xfInfo.share = 'L';
      xfInfo.note = ln.note;
      xfInfo.amount = 0;
      this.$store.commit('initXfer', xfInfo);
    },
    mouseEnter(ln) {
      const lnInfo = {};
      lnInfo.note = ln.note;
      lnInfo.style = 'background-color: green; color: white';
      this.$store.commit('setLoanHighlight', lnInfo);
    },
    mouseExit(ln) {
      const lnInfo = {};
      lnInfo.note = ln.note;
      lnInfo.style = ln.style;
      this.$store.commit('setLoanHighlight', lnInfo);
    },
    clickDetailBox(ln) {
      if (this.timeOutDoubleClick > 0) {
        this.doHistory(ln);
      }
    },
    toggleLoan(ln) {
      if (this.timeOutDoubleClick > 0) {
        this.doHistory(ln);
        return;
      }
      if (ln.isActive === false) {
        this.timeOutDoubleClick = 4;
        // utl.diag(`Set timeOutDoubleClick=${this.timeOutDoubleClick}`);
      } // 4 tenths second to do 2nd click

      const lnInfo = {};
      lnInfo.type = 'L';
      lnInfo.note = ln.note;
      lnInfo.isActive = !ln.isActive;
      this.$store.commit('setActiveLoan', lnInfo);
      this.$forceUpdate();
      let myShow = 'hide';
      if (ln.isActive) myShow = 'show';
      this.writeDiag(`toggleShare - Note=${ln.note} ${myShow}`);
      this.$store.commit('resetServerTimeout', lnInfo);
    },
    diag(msg) {
      this.$store.commit('showDiag', msg);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', message);
    },
    showConfirm(message) {
      this.$store.commit('setConfirmMessage', message);
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
  },
};
</script>

<style scoped>
  .pgStyle {

  }
  .bCard {
    padding: 4px;
    margin: 0px;
    width: 100%;
    border: solid 1px black;
  }
  .btnCollapse {
    display: inline-block;
    padding: 0px;
    width: 100%;
    background-color: lightgray;
    color: black;
    font-weight: bold;
    border: solid 2px black;
  }
  .groupHeader {
    display: inline-flex;
    padding: 0px;
    width: 100%;
  }
  .groupSection {
    display: inline-flex;
    padding: 0px;
    width: 100%;
    height: 35px;
    cursor: pointer;
  }
  .grHead {
    padding: 0px;
    background-color: floralwhite;
    color: black;
    font-weight: bold;
    border: solid 1px black;
  }
  .grPrime {
    /* display: inline-flex; */
    text-align: right;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    border: dotted 1px lightgray;
  }
  .grRight {
    text-align: right;
    padding: 0px;
    padding-right: 4px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .loanDetail {
    width: 100%;
    max-width: 400px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .detailBox {
    width: 100%;
    border: solid 4px green;
    padding: 0px;
    padding-bottom: 8px;
  }
  .detailGridBox {
    width: 100%;
    max-width: 500px;
    display: inline-block;
    horiz-align: center;
    border: solid 2px black;
    background-color: white;
  }
  .detailItem {
     width: 100%;
     /* max-width: 500px; */
     display: inline-flex;
     horiz-align: left;
     border: dotted 1px gray;
   }
  .ddLeft {
    text-align: left;
    width: 70%;
    padding: 0px;
    padding-left: 4px;
    /* height: 26px; */
    background-color: transparent;
    font-weight: bold;

  }
  .ddRight {
    text-align: right;
    width: 30%;
    padding: 0px;
    padding-right: 4px;
    /* height: 26px; */
    background-color: transparent;
    font-weight: bold;
  }
  #btnGroup {
    display: inline-block;
    width: 100%;
  }
  #btnHist {
    padding: 0px;
    margin: 1px;
    width: 120px;
    height: 35px;
    background: green;
    color: white;
    font-weight: bold;
  }
  #btnXfer {
    padding: 0px;
    margin: 1px;
    width: 120px;
    height: 35px;
    background: green;
    color: white;
    font-weight: bold;
  }
  #btnClose {
    padding: 0px;
    margin: 1px;
    width: 50px;
    height: 35px;
    font-size: 12px;
    background: red;
    color: black;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/z-loanSummary.vue